import React from 'react';
import CustomerRow from "./CustomerRow";
import TableHeader from "./Header";
import axios from 'axios';
import { url } from '../../utils/const';
import { connect } from "react-redux";

import { fetchCustomerProjectsFromMendix } from "../../actions/CustomerActions";
import { fetchMendixUser } from "../../actions/UserActions";

class Table extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showWeekend: false,
            updatedHolidaySaldo: false,

            // ✅ nieuw: pdf download status
            isDownloadingPdf: false,
            pdfProgress: null
        };

        this.onWorkSessionSaved = this.onWorkSessionSaved.bind(this);
        this.updateHolidaySaldo = this.updateHolidaySaldo.bind(this);
        this.downloadPdf = this.downloadPdf.bind(this);
    }

    async componentDidMount() {
        // Haal Mendix-user op (nodig voor projecten / rechten)
        await this.props.fetchMendixUser();

        // Alleen ophalen als de tabel zichtbaar is
        if (this.props.visible !== false) {
            this.props.fetchCustomerProjectsFromMendix(this.props.week, this.props.year);
        }

        this.setState({ updatedHolidaySaldo: false });
    }

    onWorkSessionSaved() {
        // Refresh projecten uit Mendix
        this.props.fetchCustomerProjectsFromMendix(this.props.week, this.props.year);
    }

    updateHolidaySaldo() {
        this.setState({ updatedHolidaySaldo: true });
    }

    // -------------------------------------------------
    //  TIME & DATE UTILITIES
    // -------------------------------------------------

    static datesAreEqual(date1, date2) {
        return (
            date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear()
        );
    }

    static weeksToMilliseconds(weeks) {
        return 1000 * 60 * 60 * 24 * 7 * (weeks - 1);
    }

    static firstWeekOfYear(year) {
        let date = new Date(Date.UTC(year, 0, 4));
        let day = date.getUTCDay() || 7;
        date.setUTCDate(date.getUTCDate() - day + 1);
        return date;
    }

    static getWeekNumber(d) {
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        let weekNo =
            Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
        return [d.getUTCFullYear(), weekNo];
    }

    firstDayOfWeek(week, year) {
        let date = Table.firstWeekOfYear(year);
        let weekTime = Table.weeksToMilliseconds(week);
        return date.getTime() + weekTime;
    }

    // -------------------------------------------------
    //  BUILD ROW STATISTICS
    // -------------------------------------------------

    getStats(customers, days) {
        const stats = {
            total: 0,
            days: days.map(d => ({ total: 0, date: d })),
            customers: {}
        };

        for (let customer of customers) {
            if (!customer) continue;

            stats.customers[customer.id] = {
                categories: {},
                total: 0
            };

            for (let category of (customer.categories || [])) {
                if (!category) continue;

                stats.customers[customer.id].categories[category.id] = {
                    projects: {},
                    total: 0
                };

                for (let project of (category.projects || [])) {
                    if (!project) continue;

                    stats.customers[customer.id].categories[category.id].projects[project.id] = { total: 0 };

                    for (let ws of (project.workSessions || [])) {
                        if (!ws) continue;

                        const workedDate = new Date(ws.date);
                        const hours = ws.numberOfHours || 0;

                        stats.total += hours;
                        stats.customers[customer.id].total += hours;
                        stats.customers[customer.id].categories[category.id].total += hours;
                        stats.customers[customer.id].categories[category.id].projects[project.id].total += hours;

                        days.forEach((day, index) => {
                            if (Table.datesAreEqual(workedDate, day)) {
                                stats.days[index].total += hours;
                            }
                        });
                    }
                }
            }
        }

        return stats;
    }

    // -------------------------------------------------
    //  RENDER
    // -------------------------------------------------

    render() {

        const customers = Array.isArray(this.props.customers)
            ? this.props.customers
            : [];

        const week = this.props.week;
        const year = this.props.year;

        // ✅ WEEKDAYS / WEEKEND DAYS BUILD
        let day = new Date(this.firstDayOfWeek(week, year));
        const days = [];

        const showWeekend = this.props.showWeekend === true;
        const numberOfDays = showWeekend ? 7 : 5;

        for (let i = 0; i < numberOfDays; i++) {
            days.push(new Date(day));
            day.setDate(day.getDate() + 1);
        }

        const stats = this.getStats(customers, days);
        const search = (this.props.search || "").toLowerCase();

        const rows = customers.map(customer => {
            if (!customer) return null;

            const customerName = (customer.name || "").toLowerCase();
            const directMatch = customerName.includes(search);

            // --------------------------------------
            // CASE 1: DIRECT CUSTOMER MATCH
            // --------------------------------------
            if (directMatch) {
                return (
                    <CustomerRow
                        key={customer.id}
                        showWeekend={this.props.showWeekend}
                        updateHolidaySaldo={this.updateHolidaySaldo}
                        customer={customer}
                        stats={stats.customers[customer.id]}
                        days={days}
                        onWorkSessionSaved={this.onWorkSessionSaved}
						isLoading={this.props.isLoadingCustomerProjects}
                    />
                );
            }

            // --------------------------------------
            // CASE 2: CATEGORY MATCH / PROJECT MATCH
            // --------------------------------------
            if (search.length > 0 && Array.isArray(customer.categories)) {

                for (let category of customer.categories) {
                    if (!category) continue;

                    // Category match
                    const cname = (category.name || "").toLowerCase();
                    if (cname.includes(search)) {
                        return (
                            <CustomerRow
                                key={customer.id}
                                showWeekend={this.props.showWeekend}
                                updateHolidaySaldo={this.updateHolidaySaldo}
                                customer={customer}
                                stats={stats.customers[customer.id]}
                                days={days}
                                searchQuery={this.props.search}
                                onWorkSessionSaved={this.onWorkSessionSaved}
                            />
                        );
                    }

                    // Project match
                    for (let project of (category.projects || [])) {
                        if (!project) continue;

                        const pname = (project.name || "").toLowerCase();
                        if (pname.includes(search)) {
                            return (
                                <CustomerRow
                                    key={customer.id}
                                    showWeekend={this.props.showWeekend}
                                    updateHolidaySaldo={this.updateHolidaySaldo}
                                    customer={customer}
                                    stats={stats.customers[customer.id]}
                                    days={days}
                                    searchQuery={this.props.search}
                                    onWorkSessionSaved={this.onWorkSessionSaved}
                                />
                            );
                        }
                    }
                }
            }

            return null;
        });

        // --------------------------------------
        // RENDER PDF DOWNLOAD
        // --------------------------------------

        const monthStrings = [
            "januari", "februari", "maart", "april", "mei", "juni",
            "juli", "augustus", "september", "oktober",
            "november", "december"
        ];

        // ✅ extra safety
        const sheetMonth = days.length > 0 ? days[0].getMonth() : new Date().getMonth();
        const sheetYear = days.length > 0 ? days[0].getFullYear() : new Date().getFullYear();

        const downloading = this.state.isDownloadingPdf === true;
        const progress = this.state.pdfProgress;

        const pdfDownload = (
            <div>
                <span
                    className={
                        downloading
                            ? "small hover-underline-animation"
                            : "small clickable hover-underline-animation"
                    }
                    onClick={downloading ? undefined : this.downloadPdf}
                    data-month={sheetMonth}
                    data-year={sheetYear}
                    data-per-customer={true}
                    style={downloading ? { opacity: 0.6, cursor: "default" } : undefined}
                    title={downloading ? "PDF wordt opgehaald..." : undefined}
                >
                    Download maandsheet van {monthStrings[sheetMonth]} {sheetYear}
                </span>
                &nbsp;
                <span
                    className={
                        downloading
                            ? "small hover-underline-animation"
                            : "small clickable hover-underline-animation"
                    }
                    onClick={downloading ? undefined : this.downloadPdf}
                    data-month={sheetMonth}
                    data-year={sheetYear}
                    data-per-customer={false}
                    style={downloading ? { opacity: 0.6, cursor: "default" } : undefined}
                    title={downloading ? "PDF wordt opgehaald..." : undefined}
                >
                    (per klant)
                </span>

                {downloading && (
                    <div className="small m-t-xs">
                        PDF wordt opgehaald{progress != null ? " (" + progress + "%)" : "..."}
                    </div>
                )}
            </div>
        );

        // --------------------------------------
        // FINAL RENDER
        // --------------------------------------

        return (
            <div className="registration-table clear">

                <TableHeader
                    showWeekend={this.props.showWeekend}
                    user={this.props.user}
                    week={week}
                    updatedHolidaySaldo={this.state.updatedHolidaySaldo}
                    days={stats.days}
                    total={stats.total}
                />

                {rows}

                <div className="m-t-sm m-l-xs">
                    {pdfDownload}
                    <br />
                </div>
            </div>
        );
    }

    // -------------------------------------------------
    //  PDF DOWNLOAD
    // -------------------------------------------------

    downloadPdf(event) {
        // ✅ voorkom dubbel-klikken
        if (this.state.isDownloadingPdf === true) return;

        const month =
            parseInt(event.currentTarget.getAttribute('data-month'), 10) + 1;
        const year =
            event.currentTarget.getAttribute('data-year');

        const perCustomer =
            event.currentTarget.getAttribute('data-per-customer') === "true";

        const token = localStorage.getItem("jwtToken");

        this.setState({
            isDownloadingPdf: true,
            pdfProgress: null
        });

        axios({
            url:
                `${url}/api/v1/proxy/mendix/monthsheet-pdf` +
                `?month=${month}` +
                `&year=${year}` +
                `&perCustomer=${perCustomer}`,
            method: 'GET',
            responseType: 'blob',
            headers: {
                Authorization: "bearer " + token
            },

            // ✅ optioneel: progress (werkt alleen als server Content-Length meegeeft)
            onDownloadProgress: (progressEvent) => {
                if (!progressEvent) return;

                const total = progressEvent.total;
                const loaded = progressEvent.loaded;

                if (typeof total === "number" && total > 0) {
                    const pct = Math.round((loaded / total) * 100);
                    this.setState({ pdfProgress: pct });
                }
            }

        }).then(response => {
            const fileUrl = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute(
                'download',
                perCustomer
                    ? `Maandoverzicht-${month}-${year}.pdf`
                    : `Maandoverzicht-per-klant-${month}-${year}.pdf`
            );

            document.body.appendChild(link);
            link.click();
            link.remove();

            // netjes opruimen
            window.URL.revokeObjectURL(fileUrl);

            this.setState({
                isDownloadingPdf: false,
                pdfProgress: null
            });

        }).catch(err => {
            console.error("❌ Error downloading PDF:", err);

            this.setState({
                isDownloadingPdf: false,
                pdfProgress: null
            });
        });
    }
}

// -------------------------------------------------
//  CONNECT REDUX
// -------------------------------------------------

function mapStateToProps(state) {
    return {
        user: state.user.mendixUser,
        customers: state.customers.customers || [],
        isLoadingCustomerProjects: state.customers.isLoadingCustomerProjects
    };
}

export default connect(mapStateToProps, {
    fetchMendixUser,
    fetchCustomerProjectsFromMendix
})(Table);